import { MiddlewareFunction } from '../withMiddleware';
import { ParamJsonldParamRead } from '@/api/generated';
import { KEYS } from 'utils/createKeyFactory';

export enum PARAMS_KEYS {
  USER_KYC_AMOUNT_AVAILABLE = 'USER_KYC_AMOUNT_AVAILABLE',
  USER_KYC_AMOUNT_REQUIRED = 'USER_KYC_AMOUNT_REQUIRED',
  USER_KYC_ENABLED = 'USER_KYC_ENABLED',
  POD_BY_GROUP_ENABLED = 'POD_BY_GROUP_ENABLED',
  POD_CARTAMUNDI_ORDER_PAGES_MIN = 'POD_CARTAMUNDI_ORDER_PAGES_MIN',
  POD_CARTAMUNDI_ORDER_PAGES_MAX = 'POD_CARTAMUNDI_ORDER_PAGES_MAX',
  USER_KYC_PAYIN_REQUIRED = 'USER_KYC_PAYIN_REQUIRED',
  PAYMENT_BLOCKED = 'PAYMENT_BLOCKED',
  'WALLET_CREATION_BLOCKED' = 'WALLET_CREATION_BLOCKED',
}

export type ParamsDtoParamsReponse = {
  [key in PARAMS_KEYS]?: string;
};

const apiParamsDto = (data: ParamJsonldParamRead[]): ParamsDtoParamsReponse =>
  data.reduce<ParamsDtoParamsReponse>((acc, item) => {
    if (!item.variable) {
      return acc;
    }

    return {
      ...acc,
      [item.variable]: item.value,
    };
  }, {});

export const handleFeatureFlagMiddleware: MiddlewareFunction = async (context, next) => {
  const { apiClient, queryClient } = context;
  if (queryClient) {
    await queryClient.prefetchQuery({
      queryKey: [KEYS.PARAMS],
      queryFn: async () => apiParamsDto((await apiClient.params.apiParamsGetCollection())?.data?.['hydra:member']),
    });
  }

  return next();
};
